import {
  fieldErrorsForPrefix,
  resetField,
} from "@/shared/lib/errors/validation-error";
import t from "@/lang/lang";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { useParams } from "react-router";
import {
  useQpmOfferShowQuery,
  useQpmOfferUpdatePostalAddressMutation,
  useQpmOfferUpdateServiceAddressMutation,
} from "@/services/backend/qpm/offers/api/offer-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { TextInputField } from "@/shared/components/field/input-field";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { useOfferContext } from "@/routes/processes/[processId]/qpm/offers/[offerId]/_components/offer-context";

export function AddressesRoute() {
  const params = useParams();
  const { offerId } = params;
  const {
    data: offer,
    isLoading,
    error,
  } = useQpmOfferShowQuery({ id: offerId! }, { skip: !offerId });
  const { validationError, setValidationError } = useOfferContext();
  const [updatePostalAddress, postalAddressUpdateState] =
    useQpmOfferUpdatePostalAddressMutation();

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    offer && (
      <div className="space-y-4">
        {postalAddressUpdateState.error && (
          <RTKQueryErrorAlert error={postalAddressUpdateState.error} />
        )}
        <PostalAddressCardWithMutation
          id={offer.id}
          address={offer.postalAddress}
          mutation={useQpmOfferUpdatePostalAddressMutation}
          disabled={offer.immutable}
          fieldErrors={fieldErrorsForPrefix(validationError, "postalAddress.")}
          resetFieldError={(field) =>
            setValidationError(
              resetField(validationError, `postalAddress.${field}`),
            )
          }
        />
        <Card>
          <CardHeader>
            <CardTitle>{t("Funktion des Ansprechpartners")}</CardTitle>
            <CardDescription>
              {t(
                "Wird unter dem Ansprechpartner in der Postanschrift angezeigt.",
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <TextInputField
              label={t("Funktion")}
              text={offer.postalAddressContactRole ?? ""}
              onTextChange={(postalAddressContactRole) =>
                updatePostalAddress({
                  id: offer.id,
                  postalAddress: offer.postalAddress,
                  postalAddressContactRole,
                })
              }
              disabled={offer.immutable}
            />
          </CardContent>
        </Card>
        <ServiceAddressCardWithMutation
          id={offer.id}
          address={offer.serviceAddress}
          mutation={useQpmOfferUpdateServiceAddressMutation}
          disabled={offer.immutable}
          fieldErrors={fieldErrorsForPrefix(validationError, "serviceAddress.")}
          resetFieldError={(field) =>
            setValidationError(
              resetField(validationError, `serviceAddress.${field}`),
            )
          }
        />
      </div>
    )
  );
}
